<template>
  <div class="category-admin">
    <b-form @submit="save">
      <input id="category-id" type="hidden" v-model="category.id" />
      <b-form-group label="Nome:" label-for="category-description">
        <b-form-input
          id="category-name"
          type="text"
          v-model="category.name"
          required
          :readonly="mode === 'remove'"
          placeholder="Informe o nome da Categoria..."
        />
        <p class="alertInput" v-show="nameLength">
          Nome não pode ultrapassar os 40 caracteres.
        </p>
      </b-form-group>
      <b-form-group label="Descrição:" label-for="category-description">
        <b-form-input
          id="category-description"
          type="text"
          v-model="category.description"
          required
          :readonly="mode === 'remove'"
          placeholder="Informe a descrição da Categoria..."
        />
      </b-form-group>
      <b-form-group label="Categoria Pai:" label-for="category-parentId">
        <b-form-select
          v-if="mode === 'save'"
          id="category-parentId"
          :options="categoriesFather"
          v-model="category.parentId"
        />
        <b-form-input
          v-else
          id="category-parentId"
          type="text"
          v-model="category.path"
          readonly
        />
        <p class="alertInput" v-show="verificationCategoryFather">
          Categoria pai não pode ser a mesma que está sendo editada.
        </p>
      </b-form-group>
      <b-form-group
        label="Prioridade ordenação:"
        label-for="category-sortPriority"
      >
        <b-form-input
          id="category-sortPriority"
          type="text"
          v-model="category.sortPriority"
          v-mask="'##'"
          required
          :readonly="mode === 'remove'"
        />
      </b-form-group>
      <b-form-group label="Status:" label-for="category-status">
        <b-form-select
          v-if="mode === 'save'"
          id="category-status"
          :options="status"
          v-model="category.status"
          required
        />
        <b-form-input
          v-else
          id="category-status"
          type="text"
          v-model="category.status"
          readonly
        />
      </b-form-group>
      <b-row>
        <b-col cols="12" class="d-flex justify-content-end">
          <b-button @click="reset" :disabled="progressSave">Novo</b-button>
          <b-button
            class="ml-2"
            :disabled="nameLength || verificationCategoryFather || progressSave"
            variant="primary"
            v-if="mode === 'save'"
            type="submit"
            >Salvar</b-button
          >
        </b-col>
      </b-row>
    </b-form>
    <hr />
    <div style="height: 420px; overflow: auto; position: relative">
      <table class="table table-hover table-sm small table-borderless">
        <thead>
          <tr>
            <th style="width: 50px" class="th-order text-center">ID</th>
            <th style="width: 150px" class="th-order text-start">Nome</th>
            <th style="width: 130px" class="th-order text-start">
              Categoria pai
            </th>
            <th style="width: 130px" class="th-order text-start">Caminho</th>
            <th style="width: 50px" class="th-order text-center">
              Prioridade ordenação
            </th>
            <th style="width: 50px" class="th-order text-center">Status</th>
            <th style="width: 30px" scope="col" aria-label="btn-actions" />
          </tr>
          <tr class="border-top border-bottom">
            <th style="width: 50px">
              <TableSearch
                :value="params.id"
                @input="setParams('id', $event)"
                styleSearch="width: 50px"
              />
            </th>
            <th style="width: 150px">
              <TableSearch
                :value="params.name"
                @input="setParams('name', $event)"
                styleSearch="width: 150px"
              />
            </th>
            <th style="width: 130px">
              <TableSearch
                :value="params.parentName"
                @input="setParams('parentName', $event)"
                styleSearch="width: 130px"
              />
            </th>
            <td
              style="width: 130px"
              class="search-group ng-star-inserted d-print-none"
            />
            <th style="width: 50px">
              <TableSearch
                :value="params.sortPriority"
                @input="setParams('sortPriority', $event)"
                styleSearch="width: 50px"
              />
            </th>
            <th style="width: 50px">
              <TableSearch
                :value="params.status"
                @input="setParams('status', $event)"
                styleSearch="width: 50px"
              />
            </th>
            <td
              style="width: 30px"
              class="search-group ng-star-inserted d-print-none"
            />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="category in categories"
            :class="
              category.status === 'INATIVO'
                ? 'table-secondary text-secondary'
                : ''
            "
            :key="category.id"
          >
            <th style="width: 50px" class="th-order text-center">
              {{ category.id }}
            </th>
            <th style="width: 150px" class="th-order text-start">
              {{ category.name }}
            </th>
            <th style="width: 130px" class="th-order text-start">
              {{ category.parentName }}
            </th>
            <th style="width: 130px" class="th-order text-start">
              {{ category.path }}
            </th>
            <th style="width: 50px" class="th-order text-center">
              {{ category.sortPriority }}
            </th>
            <th style="width: 50px" class="th-order text-center">
              {{ category.status }}
            </th>
            <th style="width: 30px" class="th-order text-center">
              <div
                style="cursor: pointer"
                @click="loadCategory(category)"
                class="mr-2"
              >
                <svg
                  style="font-size: 1.3rem"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="edit"
                  class="svg-inline--fa fa-edit fa-w-18 text-success"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path
                    fill="currentColor"
                    d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
                  ></path>
                </svg>
              </div>
            </th>
          </tr>
        </tbody>
      </table>
      <div v-show="progress" class="text-center">
        <p>Carregando...</p>
        <b-spinner variant="dark" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import TableSearch from "../TableSearch.vue";

export default {
  name: "CategoryAdmin",
  components: { TableSearch },
  data: function () {
    return {
      progressSave: false,
      mode: "save",
      category: {
        id: null,
        name: "",
        description: "",
        parentId: null,
        sortPriority: null,
        status: null,
      },
      progress: true,
      params: {},
      categories: [],
      categoriesFather: [],
      status: ["ATIVO", "INATIVO"],
    };
  },
  watch: {
    category() {},
  },
  computed: {
    nameLength() {
      return `${this.category.name}`.length > 40 ? true : false;
    },
    verificationCategoryFather() {
      if (
        this.category.id !== null &&
        this.category.parentId !== null &&
        this.category.id === this.category.parentId
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    setParams(attribute, newValue) {
      this.params[attribute] = newValue;
      this.loadCategories();
    },
    loadCategories() {
      this.progress = true;
      this.categories = [];
      const url = `${baseApiUrl}/api/categorias/filtro`;
      axios
        .get(url, {
          params: {
            ...this.params,
          },
        })
        .then((res) => {
          this.progress = false;
          this.categories = res.data.content.map((category) => {
            return { ...category, value: category.id, text: category.path };
          });
        });
    },
    loadCategoriesFather() {
      const url = `${baseApiUrl}/api/categorias`;
      axios.get(url).then((res) => {
        this.categoriesFather = res.data.map((category) => {
          return { ...category, value: category.id, text: category.path };
        })
        .sort((a, b) => a.text.localeCompare(b.text));
      });
    },
    reset() {
      this.mode = "save";
      this.category = {
        name: "",
        description: "",
        parentId: null,
        sortPriority: null,
        status: null,
      };
      this.params = {};
      this.loadCategories();
    },
    save(event) {
      event.preventDefault();
      this.progressSave = true;
      const method = this.category.id ? "put" : "post";
      const id = this.category.id ? `/${this.category.id}` : "";
      const category = {
        name: this.category.name,
        description: this.category.description,
        parentId: this.category.parentId,
        sortPriority: this.category.sortPriority,
        status: this.category.status,
      };
      axios[method](`${baseApiUrl}/api/categorias${id}`, category)
        .then((res) => {
          if (res !== undefined) {
            // console.log(res);
            const category = res.data;
            if (this.category.id) {
              this.categories = this.categories.map((c) => {
                if (c.id === category.id) {
                  return {
                    ...category,
                  };
                }
                return c;
              });
              this.mode = "save";
              this.category = {
                id: null,
                name: "",
                description: "",
                parentId: null,
                sortPriority: null,
                status: null,
              };
            } else {
              this.reset();
            }
            this.progressSave = false;
            this.$toasted.global.defaultSuccess();
            // this.reset();
          }
          this.progressSave = false;
        })
        .catch((res) => {
          showError(res);
          this.progressSave = false;
        });
    },
    loadCategory(category, mode = "save") {
      this.mode = mode;
      this.category = { ...category };
    },
  },
  mounted() {
    this.loadCategories();
    this.loadCategoriesFather();
  },
};
</script>

<style>
.alertInput {
  margin-top: 5px;
  font-size: 80%;
  color: red;
}
</style>